import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 px-3 py-5 rounded-xl border border-gray-lp-1300" }
const _hoisted_2 = { class: "w-full flex flex-row gap-4 content-center" }
const _hoisted_3 = { class: "flex flex-grow" }
const _hoisted_4 = { class: "content-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_6 = { class: "w-full flex flex-row gap-4" }
const _hoisted_7 = { class: "w-full flex-1" }
const _hoisted_8 = { class: "w-full flex-1" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "mt-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Title, {
            class: "content-center",
            fontSize: 20,
            label: _ctx.$t('clientManagement.registrationBranchForm.returnConfig.title')
          }, null, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Toggle, {
            onChange: _ctx.onUpdateStatus,
            modelValue: _ctx.modelValue.isActive,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.isActive = $event)),
            textActive: "",
            textInactive: ""
          }, null, 8, ["onChange", "modelValue"])
        ])
      ]),
      (_ctx.modelValue.isActive)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_DataWrapper, {
                  optional: "",
                  label: _ctx.$t('clientManagement.registrationBranchForm.returnConfig.confirmationLimit'),
                  fontSize: 14
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      type: "number",
                      placeholder: _ctx.$t('clientManagement.registrationBranchForm.returnConfig.enterConfirmationLimit'),
                      modelValue: _ctx.modelValue.limitConfirm,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.limitConfirm = $event)),
                      suffix: _ctx.$t('clientManagement.managementDetail.day')
                    }, null, 8, ["placeholder", "modelValue", "suffix"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('clientManagement.registrationBranchForm.returnConfig.reasonNeedsConfirmation'),
                  optional: "",
                  fontSize: 14
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createVNode(_component_MultipleSelectSearch, {
                      options: _ctx.reasonList,
                      modelValue: _ctx.modelValue.returnConfigReasonIds,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.returnConfigReasonIds = $event)),
                      modalTitle: _ctx.$t('clientManagement.registrationBranchForm.returnConfig.returnReasonList'),
                      keyName: "name",
                      keyValue: "value",
                      placeholder: _ctx.$t('clientManagement.registrationBranchForm.returnConfig.selectReason'),
                      "custom-display-all": _ctx.$t('clientManagement.registrationBranchForm.returnConfig.allReasons'),
                      onFilter: _ctx.onSearchAddObject
                    }, null, 8, ["options", "modelValue", "modalTitle", "placeholder", "custom-display-all", "onFilter"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}